/*global Daon */
/*eslint no-undef: "error"*/

import React, { Component } from "react";
import { string, func, number, bool } from "prop-types";

class FaceCaptureUI extends Component {
  static propTypes = {
    url: string,
    width: number,
    height: number,
    onInitialized: func,
    onCameraStarted: func,
    cameraPermissionDenied: func,
    cameraRetryInit: bool,
  };

  state = {
    refocusedPage: false,
  };

  constructor(props) {
    super(props);
    this.videoRef = new React.createRef();
  }

  componentDidMount() {
    const { url, width, height } = this.props;
    this.fc = new Daon.FaceCapture({ url, width, height });
    if (typeof this.props.onInitialized === "function")
      this.props.onInitialized(this.fc);
    this.initializeCamera();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.retryCameraInit !== this.props.retryCameraInit)
      this.initializeCamera();
  }

  componentWillUnmount() {
    if (this.fc) {
      if (this.videoRef && this.videoRef.current) {
        this.videoRef.current.srcObject = undefined;
      }
      this.fc.stopAutoCapture();
      this.fc.stopCamera();
    }
  }

  initializeCamera() {
    this.fc
      .startCamera(this.videoRef.current)
      .then(() => {
        if (typeof this.props.onCameraStarted === "function")
          this.props.onCameraStarted(this.fc, this.videoRef.current);
      })
      .catch(() => this.props.cameraPermissionDenied());
  }

  render() {
    const isEdge = window.navigator.userAgent.indexOf("Edge") > -1;
    const videoClassName = isEdge ? "ui-canvas scale-edge" : "ui-canvas";
    const containerClassName = isEdge
      ? "ui-canvas-container hiddenEdge"
      : "ui-canvas-container";

    return (
      <div className={containerClassName}>
        <video className={videoClassName} ref={this.videoRef}></video>
        {isEdge ? null : <div className={this.props.className || ""}></div>}
      </div>
    );
  }
}

export default FaceCaptureUI;
